/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};

  Shopify.theme.jsFeaturedCollection = {

    init: function ($section) {

      const _this = this;

      $section.find('[data-slider]').each(function () {
        const $el = $(this);

        if ($el.is(':visible')) {
          _this.initSliderFromData($el);
        }
      });

      this.initCollectionTabs($section);

      var $slider = $section.find('.collection-list-title');

      function toggleIconListSlider() {
        if (!$.fn.flickity) return;

        var isMobile = window.matchMedia('(max-width: 480px)').matches;

        if (isMobile) {
          if ($slider.hasClass('flickity-enabled')) return;

          $slider.flickity({
            cellSelector: '.collection-list-title li',
            cellAlign: 'center',
            contain: true,
            groupCells: true,
            prevNextButtons: true,
            pageDots: false
          });

        } else {
          if ($slider.hasClass('flickity-enabled')) {
            try { $slider.flickity('destroy'); } catch (e) {}
          }
        }
      }

      toggleIconListSlider();
      $(window).on('resize orientationchange', toggleIconListSlider);
      document.addEventListener('shopify:section:load', toggleIconListSlider);
    },

    getPanelData: function ($el, $section) {
      let data = {};
      let jsonEl = $el.find('[data-section-data]');
      if (!jsonEl.length && $section) {
        jsonEl = $section.find('[data-section-data]').first();
      }
      if (jsonEl.length) {
        try {
          data = JSON.parse(jsonEl.html());
        } catch (e) {}
      }
      return data;
    },

    initSliderFromData: function ($el) {
      if (!$el || !$el.length) return;

      const data = this.getPanelData($el, $el.closest('[data-section-id]'));

      if (data.collection_style !== 'slider') return;

      if ($el.data('flickity')) {
        try {
          $el.flickity('resize');
          $el.flickity('reposition');
        } catch(e){}
        return;
      }

      const slider = $el.flickity({
        lazyLoad: 2,
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        wrapAround: false,
        contain: true,
        groupCells: true,
        percentPosition: false,
        cellSelector: '.product__thumbnail',
        pageDots: true,
        prevNextButtons: data.products_limit > data.products_per
      });

      const _this = this;

      $el.one('ready.flickity', () => {
        _this.markSliderReady($el);
      });

      $el.one('settle.flickity', () => {
        _this.markSliderReady($el);
      });

      slider.on('settle.flickity', function () {
        slider.flickity('resize');
      });
    },

    markSliderReady: function ($el) {
      if (!$el || !$el.length) return;
      $el.addClass('featured-slider-ready');
    },

    initCollectionTabs: function ($section) {

      const _this = this;

      const $tabs = $section.find('.collection-list-title li[data-collection-title]');
      const $panels = $section.find('[data-collection-product]');

      if (!$tabs.length || !$panels.length) return;

      const norm = (str) => {
        return (str || '').toString().trim().toLowerCase().replace(/\s+/g, '_');
      };

      const showPanel = (keyRaw) => {

        const key = norm(keyRaw);

        $tabs.removeClass('active');
        $panels.removeClass('active').addClass('is-hidden').hide();

        const $activeTab = $tabs.filter(function () {
          return norm($(this).attr('data-collection-title')) === key;
        });

        $activeTab.addClass('active');

        const $activePanel = $panels.filter(function () {
          return norm($(this).attr('data-collection-product')) === key;
        });

        if (!$activePanel.length) return;

        $activePanel.addClass('active').removeClass('is-hidden').show();
        setTimeout(() => {
          _this.initSliderFromData($activePanel);
        }, 60);
      };

      $section.off('click.collectionTabs', '.collection-list-title li[data-collection-title]');
      $section.on('click.collectionTabs', '.collection-list-title li[data-collection-title]', function (e) {
        e.preventDefault();
        showPanel($(this).attr('data-collection-title'));
      });

      const initial =
        $tabs.filter('.active').attr('data-collection-title') ||
        $tabs.first().attr('data-collection-title');

      showPanel(initial);
    },

    unload: function ($section) {
      $section.off('click.collectionTabs', '.collection-list-title li[data-collection-title]');

      let $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }

})();